import { defineMessages } from "@mnemonic/intl";

export const commonMessages = defineMessages({
  APIstatus: { id: "APIstatus", defaultMessage: "API status" },
  All: { id: "All", defaultMessage: "All" },
  Argusservice: { id: "Argusservice", defaultMessage: "Argus service" },
});
